import React, { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Contexts/AuthProvider/AuthProvider';
import { FaGoogle } from "react-icons/fa";
import toast from 'react-hot-toast';
import useTitle from '../../hooks/useTittle';



const Login = () => {

    useTitle("Login")

    const { login, googleSignIn } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate()
    const from = location.state?.from?.pathname || "/";

    const handleLogin = event => {
        event.preventDefault()

        const form = event.target;
        const email = form.email.value;
        const password = form.password.value;

        login(email, password)
            .then(result => {
                const user = result.user;
                console.log(user)
                form.reset()
                toast.success("Login Succesfully")
                navigate(from, { replace: true })
            })
            .catch(e => console.error(e))

    }

    const handleGoogleSignIn = () => {
        googleSignIn()
            .then(result => {
                const user = result.user;
                console.log(user)
                toast.success("Login Succesfully")
                navigate(from, { replace: true })
            })
            .catch(e => console.error(e))
    }
    return (
        <div>
            <div className=" w-full ">
                <div className="w-[360px] mx-auto py-2 mt-8">
                    <div className="card shadow-2xl bg-base-100 ">
                        <form onSubmit={handleLogin} className="card-body">
                            <h1 className="text-3xl text-center font-bold">Login</h1>
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Email</span>
                                </label>
                                <input type="text" name='email' placeholder="email" className="input input-bordered" required />
                            </div>
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Password</span>
                                </label>
                                <input type="text" name='password' placeholder="password" className="input input-bordered" required />
                            </div>
                            <div className="form-control mt-2">
                                <input className="btn btn-info text-gray-200" type="submit" value="Login" />
                            </div>
                            <div>
                                <p className='text-center font-semibold'>Or</p>
                                <button onClick={handleGoogleSignIn} className="btn  btn-outline btn-primary mt-2 w-full"><FaGoogle className='text-orange-500'></FaGoogle></button>
                            </div>
                            <p className='text-center text-sm'>New to HealthCare <Link className='text-orange-600 font-bold' to="/signup">Sign Up</Link> </p>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;